import React, { useCallback } from 'react'

import { connect } from 'react-redux'

import { trackDiscountVisibilityBannerAppearance } from 'actions/tracking'
import {
  signupDismissDiscountAppliedBar,
  signupNextStep,
  signupSetStep,
  signupStepsReceive,
} from 'routes/Signup/signupActions'

import { useDiscountAppliedData } from '../../components/DiscountAppliedBar/discountAppliedBarHooks'
import { Signup } from './Signup'

const mapStateToProps = (state, ownProps) => ({
  secondarySlug: ownProps.params.secondarySlug,
  stepNames: state.signup.getIn(['wizard', 'stepNames']),
  orderDiscount: state.promoStore[state.promoCurrent]?.details?.['discount-whole-order-percent'],
  isDiscountAppliedBarDismissed: state.signup.get('isDiscountAppliedBarDismissed'),
})

const SignupPure = (props) => {
  const { isDiscountEnabled, discountAppliedTitle, discountAppliedBody, discountAmount } =
    useDiscountAppliedData()
  const trackDiscountVisibility = useCallback(
    (wizardStep) => trackDiscountVisibilityBannerAppearance(wizardStep),
    [],
  )

  return (
    <Signup
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      isDiscountEnabled={isDiscountEnabled}
      discountAmount={discountAmount}
      discountAppliedTitle={discountAppliedTitle}
      discountAppliedBody={discountAppliedBody}
      trackDiscountVisibility={trackDiscountVisibility}
    />
  )
}

const SignupContainer = connect(mapStateToProps, {
  goToStep: signupNextStep,
  signupStepsReceive,
  signupDismissDiscountAppliedBar,
  signupSetStep,
})(SignupPure)

export { SignupContainer }
